import React from "react";
import { useNavigate } from "react-router-dom";
import { User, Phone, Building2, Languages } from "lucide-react";
import TopBar from "@/components/TopBar";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";

export default function Profile() {
  const nav = useNavigate();
  const { user } = useAuth();
  const { t, lang, setLang } = useLang();

  const homeFor = {
    shopkeeper: "/shop", retailer: "/shop", wholesaler: "/shop",
    salesman: "/salesman", manager: "/manager",
    management: "/management", super_admin: "/admin"
  };

  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <TopBar title={t("profile")} onBack={() => nav(homeFor[user?.role] || "/")} />
      <div className="max-w-md mx-auto p-5 sm:p-6 fade-up">
        <div className="bg-white rounded-3xl p-6 soft-shadow mb-5">
          <div className="flex items-center gap-4 mb-5">
            <div className="w-20 h-20 rounded-3xl bg-gradient-to-br from-[#0055FF] to-[#0044CC] grid place-items-center text-white text-3xl font-bold heading-font shadow-md">
              {user?.name?.[0]?.toUpperCase()}
            </div>
            <div className="min-w-0">
              <div className="heading-font text-2xl font-bold text-[#1D1D1F] truncate" data-testid="profile-name">{user?.name}</div>
              <div className="text-sm text-[#86868B] uppercase tracking-wider">{user?.role?.replace("_", " ")}</div>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex items-center gap-3 p-3 bg-[#F5F5F7] rounded-2xl">
              <Phone className="w-5 h-5 text-[#0055FF]" />
              <div>
                <div className="text-xs text-[#86868B] uppercase tracking-wider">{t("phone")}</div>
                <div className="font-semibold" data-testid="profile-phone">{user?.phone}</div>
              </div>
            </div>
            {user?.shop && (
              <div className="flex items-center gap-3 p-3 bg-[#F5F5F7] rounded-2xl">
                <Building2 className="w-5 h-5 text-[#0055FF]" />
                <div>
                  <div className="text-xs text-[#86868B] uppercase tracking-wider">{t("shop_name")}</div>
                  <div className="font-semibold">{user.shop.name}</div>
                </div>
              </div>
            )}
            {user?.district && (
              <div className="flex items-center gap-3 p-3 bg-[#F5F5F7] rounded-2xl">
                <Building2 className="w-5 h-5 text-[#0055FF]" />
                <div>
                  <div className="text-xs text-[#86868B] uppercase tracking-wider">{t("district")}</div>
                  <div className="font-semibold">{user.district.name}</div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="bg-white rounded-3xl p-6 soft-shadow">
          <div className="flex items-center gap-2 mb-3">
            <Languages className="w-5 h-5 text-[#0055FF]" />
            <h3 className="heading-font font-bold text-lg">{t("choose_language")}</h3>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <button
              data-testid="profile-lang-en"
              onClick={() => setLang("en")}
              className={`btn-massive py-5 ${lang === "en" ? "ring-2 ring-[#0055FF]" : ""}`}
            >
              <span className="heading-font text-2xl font-bold text-[#0055FF]">EN</span>
              <span className="text-sm font-semibold">English</span>
            </button>
            <button
              data-testid="profile-lang-ta"
              onClick={() => setLang("ta")}
              className={`btn-massive py-5 ${lang === "ta" ? "ring-2 ring-[#0055FF]" : ""}`}
            >
              <span className="heading-font text-2xl font-bold text-[#0055FF]">த</span>
              <span className="text-sm font-semibold">தமிழ்</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
